import { Command } from "commander";
import chalk from "chalk";
import { createRouter } from "@fathom/router";
import type { TaskContext, BudgetState } from "@fathom/router";
import { warnAction } from "../ux/errors.js";

export const routeCommand = new Command("route")
  .description("Get a model recommendation for a task")
  .argument("<description>", "Task description")
  .option("--budget <amount>", "Monthly budget limit in USD", parseFloat)
  .option("--complexity <size>", "Task complexity (S/M/L/XL)", "M")
  .option("--category <cat>", "Task category")
  .action(
    (
      description: string,
      options: { budget?: number; complexity?: string; category?: string },
    ) => {
      const router = createRouter();

      const task: TaskContext = {
        description,
        complexity: (options.complexity as TaskContext["complexity"]) ?? "M",
        category: options.category,
      };

      const budgetState: BudgetState | undefined = options.budget
        ? {
            monthlyLimit: options.budget,
            currentSpend: 0,
            daysRemaining: 30,
            currency: "USD",
          }
        : undefined;

      const rec = router.recommend(task, budgetState);

      const truncated =
        description.length > 60 ? description.slice(0, 57) + "..." : description;

      console.log(chalk.bold("\nFathom -- Model Recommendation"));
      console.log(chalk.dim("-".repeat(50)));
      console.log(`  Task:         ${truncated}`);
      console.log(`  Complexity:   ${task.complexity}`);
      console.log(chalk.dim("-".repeat(50)));
      console.log(`  Model:        ${rec.model}`);
      console.log(`  Provider:     ${rec.provider} (${rec.tier})`);
      console.log(`  Reason:       ${rec.reason}`);
      console.log(`  Est. cost:    $${rec.estimatedCost.toFixed(2)}`);
      console.log(
        `  Confidence:   ${rec.confidence} (${rec.dataPoints} data points)`,
      );

      if (rec.budgetWarning) {
        console.log(chalk.yellow(`  Budget:       ${rec.budgetWarning}`));
      }

      if (rec.deprecationWarning) {
        console.log(chalk.yellow(`  Deprecated:   ${rec.deprecationWarning}`));
      }

      if (rec.alternatives.length > 0) {
        console.log(chalk.dim("\n  Alternatives:"));
        for (const alt of rec.alternatives) {
          console.log(
            `    ${alt.model} — ${alt.reason} ($${alt.estimatedCost.toFixed(2)})`,
          );
        }
      }

      console.log("");
    },
  );
